import { useEffect } from 'react'

import { useToPrepareSearchFiltersParams, useGetSearchResultsCountQuery } from 'features/meetings'

import { BaseFilterModal } from './base_filter_modal'
import { DateRange } from './components/date_range'
import { EventTypesSelect } from './components/event_types_select'
import { QueryMatches } from './components/query_matches'
import { Role } from './components/role'
import { SchedulingMethod } from './components/scheduling_method'
import { Status } from './components/status'

const AdvancedFilters = ({ currentFilters, setCurrentFilters }) => {
  const getStatusParams = (params) => ({
    status_ids: params.status
  })

  const setStatusFilter = (params) => {
    setCurrentFilters({
      ...currentFilters,
      status: params.status_ids
    })
  }

  const getSchedulingMethodParams = (params) => ({
    scheduling_methods: params.schedulingMethod
  })

  const setSchedulingMethodFilter = (params) => {
    setCurrentFilters({
      ...currentFilters,
      schedulingMethod: params.scheduling_methods
    })
  }

  const getRoleParams = (params) => ({
    host_ids: params.role
  })

  const setRoleFilter = (params) => {
    setCurrentFilters({
      ...currentFilters,
      role: params.host_ids
    })
  }

  return (
    <>
      <Status params={getStatusParams(currentFilters)} onChange={setStatusFilter} />
      <SchedulingMethod params={getSchedulingMethodParams(currentFilters)} onChange={setSchedulingMethodFilter} />
      <Role params={getRoleParams(currentFilters)} onChange={setRoleFilter} />
    </>
  )
}

const useResultsCount = ({ query, filters }) => {
  const filterParams = useToPrepareSearchFiltersParams(filters)
  const { data, isLoading, isError } = useGetSearchResultsCountQuery({
    query,
    ...filterParams,
  })

  if (isLoading || isError) {
    return 0
  }

  return data.meetings_search.total
}

export const SearchFilterModal = ({
  isOpen,
  onClose,
  filters,
  setFilters,
  searchQuery,
  resetParams,
  currentFilters,
  setCurrentFilters,
  triggerRef
}) => {
  const resultCount = useResultsCount({ query: searchQuery, filters: currentFilters })

  const getDateRangeParams = (params) => ({
    period: params.dateRange.period,
    start_date: params.dateRange.start,
    end_date: params.dateRange.end
  })

  const setDateRangeFilter = (params) => {
    setCurrentFilters({
      ...currentFilters,
      dateRange: {
        period: params.period,
        start: params.start_date,
        end: params.end_date
      }
    })
  }

  const getEventTypesParams = (params) => ({
    event_type_ids: params.eventTypeIds
  })

  const setEventTypesFilter = (params) => {
    setCurrentFilters({
      ...currentFilters,
      eventTypeIds: params.event_type_ids
    })
  }

  const handleApply = () => {
    setFilters(currentFilters)
    onClose()
  }

  const handleClear = () => {
    setCurrentFilters(resetParams)
  }

  useEffect(() => {
    setCurrentFilters(filters)
  }, [filters, setCurrentFilters])

  return (
    <BaseFilterModal
      isOpen={isOpen}
      onClose={onClose}
      onApply={handleApply}
      onClear={handleClear}
      advancedFilters={<AdvancedFilters currentFilters={currentFilters} setCurrentFilters={setCurrentFilters} />}
      resultCount={resultCount}
      triggerRef={triggerRef}
    >
      <QueryMatches params={currentFilters} onChange={setCurrentFilters} />
      <DateRange params={getDateRangeParams(currentFilters)} onApply={setDateRangeFilter} />
      <EventTypesSelect params={getEventTypesParams(currentFilters)} onApply={setEventTypesFilter} />
    </BaseFilterModal>
  )
}
